export enum RoutingPath {
  Login = "login",
  Groups = "groups",
  Employees = "employees",
  Settings = "settings",
  NotFound = "not-found",
}
